import React from 'react';
import { Gem, Smartphone, MessageCircle, MapPin, Clock, Shield, Monitor, Headphones, Check } from 'lucide-react';
const features = [{
  icon: <Gem className="w-6 h-6" data-id="element-32" />,
  title: 'Diseño profesional y moderno',
  description: 'Tu negocio se verá tan serio como los grandes del mercado.'
}, {
  icon: <Smartphone className="w-6 h-6" data-id="element-33" />,
  title: 'Optimizada para móviles',
  description: 'El 80% de tus clientes te buscan desde su celular.'
}, {
  icon: <MessageCircle className="w-6 h-6" data-id="element-34" />,
  title: 'Botón de contacto directo',
  description: 'WhatsApp, teléfono o formulario de contacto a un clic.'
}, {
  icon: <MapPin className="w-6 h-6" data-id="element-35" />,
  title: 'SEO Local Incluido',
  description: 'Configuración básica para que te encuentren en tu zona.'
}, {
  icon: <Clock className="w-6 h-6" data-id="element-36" />,
  title: 'Entrega en 7 días',
  description: 'Porque tu negocio no puede seguir esperando para crecer.'
}, {
  icon: <Shield className="w-6 h-6" data-id="element-37" />,
  title: 'Seguridad SSL',
  description: 'Certificado de seguridad incluido para proteger a tus clientes.'
}, {
  icon: <Monitor className="w-6 h-6" data-id="element-38" />,
  title: 'Sección de servicios clara',
  description: 'Para que sepan exactamente qué ofreces y a qué precio.'
}, {
  icon: <Headphones className="w-6 h-6" data-id="element-39" />,
  title: 'Llamadas a la acción',
  description: 'Estratégicamente diseñadas para que el cliente actúe de inmediato.'
}];
export function Features() {
  return <section className="py-24 px-6 bg-background relative" data-id="element-40">
      <div className="max-w-7xl mx-auto" data-id="element-41">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-42">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-6" data-id="element-43">
            ¿Qué Incluye Tu Landing Page de{' '}
            <span className="text-primary" data-id="element-44">Krove Latam?</span>
          </h2>
          <p className="text-xl text-text-secondary" data-id="element-45">
            Cada página que creamos está diseñada para una sola cosa:{' '}
            <strong className="text-white font-medium" data-id="element-46">
              convertir visitantes en clientes.
            </strong>
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-20" data-id="element-47">
          {features.map((feature, index) => <div key={index} className="glass-panel p-6 rounded-2xl hover:bg-white/[0.05] transition-colors duration-300" data-id="element-48">
              <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center text-primary mb-5 border border-primary/20" data-id="element-49">
                {feature.icon}
              </div>
              <h3 className="text-lg font-medium text-white mb-2" data-id="element-50">
                {feature.title}
              </h3>
              <p className="text-sm text-text-secondary leading-relaxed" data-id="element-51">
                {feature.description}
              </p>
            </div>)}
        </div>

        {/* Transformation Section */}
        <div className="max-w-4xl mx-auto glass-panel rounded-3xl p-8 md:p-12 relative overflow-hidden" data-id="element-52">
          <div className="absolute top-0 right-0 w-full h-full bg-gradient-to-br from-accent-start/5 to-transparent pointer-events-none" data-id="element-53"></div>

          <h3 className="text-2xl md:text-3xl font-serif font-bold mb-8 text-center" data-id="element-54">
            Lo Que Significa Esto Para Tu Negocio
          </h3>

          <p className="text-center text-text-secondary mb-10" data-id="element-55">
            No te estamos vendiendo una página web.{' '}
            <strong className="text-white" data-id="element-56">
              Te estamos vendiendo más clientes.
            </strong>
          </p>

          <div className="space-y-6" data-id="element-57">
            {['El spa de uñas que antes dependía de recomendaciones → ahora recibe citas nuevas cada semana de personas que la encontraron en Google', 'La barbería que solo tenía Instagram → ahora tiene una página que proyecta profesionalismo y confianza', 'El fisioterapeuta que trabajaba solo de boca en boca → ahora tiene pacientes nuevos que llegaron solos', 'El servicio de limpieza que no podía crecer → ahora tiene una presencia digital que lo separa del resto'].map((text, i) => <div key={i} className="flex items-start gap-4" data-id="element-58">
                <div className="mt-1 shrink-0 w-6 h-6 rounded-full bg-accent-start/20 flex items-center justify-center" data-id="element-59">
                  <Check className="w-4 h-4 text-accent-start" data-id="element-60" />
                </div>
                <p className="text-text-secondary leading-relaxed" data-id="element-61">
                  {text.split('→').map((part, idx) => idx === 0 ? <span key={idx} data-id="element-62">
                        {part} <span className="text-accent-start mx-1" data-id="element-63">→</span>
                      </span> : <strong key={idx} className="text-white font-medium" data-id="element-64">
                        {part}
                      </strong>)}
                </p>
              </div>)}
          </div>

          <div className="mt-10 text-center" data-id="element-65">
            <p className="text-xl font-serif italic text-white" data-id="element-66">
              Ese puedes ser tú. Muy pronto.
            </p>
          </div>
        </div>
      </div>
    </section>;
}